<template>
  <div class="seasidetms_product product-list-item">
    <div class="product-list-image">
      <i class="ico-bage" v-if="product.bage">
        <!-- {{ $t(`badge.${product.bage}`) }} -->
        {{ $t(`bage.${product.bage}`) }}
      </i>
      <figure class="seasidetms_product_img">
        <a
          href="#"
          @click.stop.prevent="onDetails"
          class="ico-details ico-details2 icon-search icon-quick"
        >
          &nbsp;
        </a>
        <router-link
          :to="
            lang
              ? '/' + lang + '/product/' + categoryPath + '/' + product.slug
              : '/product/' + categoryPath + '/' + product.slug
          "
          @click.native="onClickProdcut(product)"
        >
          <img
            :width="productImgWidth"
            :height="productImgHeight"
            :src="productImgSrc"
            :alt="$h.getAlt(productName)"
            :title="productName"
          />
        </router-link>
        <!--        :srcset="productImgSrcSet"-->
        <!--        :sizes="productImgSizes"-->
      </figure>
      <span class="out-of-stock" v-if="!product.stock">
        {{ $t('outOfStock') }}
      </span>
    </div>
    <div class="product-list-content">
      <div class="seasidetms_product_inner">
        <header class="seasidetms_product_header entry-header">
          <div class="h3 seasidetms_product_title entry-title">
            <router-link
              :to="
                lang
                  ? '/' + lang + '/product/' + categoryPath + '/' + product.slug
                  : '/product/' + categoryPath + '/' + product.slug
              "
              @click.native="onClickProdcut(product)"
            >
              {{ productName }}
            </router-link>
          </div>
        </header>
        <div class="seasidetms_product_info_wrap">
          <div class="seasidetms_product_info">
            <span class="price" v-if="product.newPrice">
              <span class="woocommerce-Price-amount amount">
                <s>
                  <span>
                    <span class="woocommerce-Price-currencySymbol">₴</span>
                  </span>
                  {{ product.price }}
                </s>
              </span>
              <span
                style="margin-left: 50px; color: rgba(255, 67, 0, 0.9)"
                class="price-ukr"
              >
                ₴<span v-html="$h.formatPrice(product.newPrice)"></span>
              </span>
            </span>
            <span class="price" v-else>
              <span class="woocommerce-Price-amount amount">
                <span>
                  <span class="woocommerce-Price-currencySymbol">₴</span>
                </span>
                {{ product.price }}
              </span>
              <span style="margin-left: 50px" class="price-ukr">
                <span v-html="$h.formatPrice(product.price)"></span>грн
              </span>
            </span>
          </div>
          <rating :rating="product.rating" />
          <div class="seasidetms_product_add_wrap">
            <div class="seasidetms_product_add_inner">
              <a
                href="#"
                id="add-to-cart-button"
                data-product_id="18122"
                data-product_sku=""
                class="seasidetms_product_button add_to_cart_button seasidetms_add_to_cart_button product_type_simple ajax_add_to_cart"
                :title="$t('toCart')"
                @click.stop.prevent="onAddToCart"
                v-if="!product.preorder && product.stock && !inCart"
              >
                <span>
                  {{ $t('toCart') }}
                </span>
              </a>
              <router-link
                id="add-to-cart-button"
                :to="lang ? '/' + lang + '/cart' : '/cart'"
                class="seasidetms_product_button wc-forward"
                :title="$t('showCart')"
                v-if="!product.preorder && product.stock && inCart"
              >
                <span>
                  {{ $t('showCart') }}
                </span>
              </router-link>
              <a
                href="#"
                class="seasidetms_product_button"
                @click.stop.prevent="onNotifyOnStock(product)"
                v-if="!product.preorder && !product.stock"
              >
                {{ $t('notifyOnStock') }}
              </a>
              <a
                href="#"
                class="seasidetms_product_button"
                @click.stop.prevent="onPreOrder(product)"
                v-if="product.preorder"
              >
                {{ $t('preorder') }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Rating from '@/components/Rating'
import ProductItemMixin from '@/components/product/ProductItemMixin'

export default {
  name: 'ProductItem',
  components: { Rating },
  mixins: [ProductItemMixin],
  data() {
    return {
      lang: '',
    }
  },
  beforeMount() {
    this.lang = this.$store.getters.lang
  },
  updated() {
    this.lang = this.$store.getters.lang
  },
}
</script>

<style>
.product-list-item {
  list-style-position: inside;
  list-style-type: none;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  /*justify-content: space-between;
  align-content: space-between;*/
  /*align-items: flex-end;*/
  box-shadow: inset 0 0 0 1px rgba(221, 221, 221, 1);
  /*position: relative;*/
  border-radius: 10px;
  /*transition: border-color .3s ease;*/
  overflow: hidden;
  border-color: transparent;
  border-style: solid;
  border-width: 1px;
  padding: 4px 1px 4px 1px !important;
  margin-bottom: 16px;
}
.product-list-image {
  flex-grow: 1;
  min-width: 220px;
}
.product-list-image figure {
  margin: 0 !important;
}
.product-list-image img {
  max-width: 247px !important;
  max-height: 247px !important;
  margin: 0 !important;
}
.product-list-content {
  flex-grow: 4;
}
.product-list-content .h3 {
  padding-top: 20px;
}
.product-list-content .seasidetms_product_inner {
  max-width: 340px;
}
@media only screen and (max-width: 768px) {
  /* todo */
}

.ico-details2 {
  right: 86px !important;
  top: 2px !important;
}
</style>
